import type { SubLabelData } from "@/hooks/predictionMarket/usePredictionMarketLabels";
import { cn } from "@roman/shared/utils";

interface SubLabelSelectorProps {
  subLabels: SubLabelData[];
  selectedSubLabel: SubLabelData;
  onSubLabelSelect: (label: SubLabelData) => void;
  className: string;
}

export const SubLabelSelector = ({
  subLabels,
  selectedSubLabel,
  onSubLabelSelect,
  className,
}: SubLabelSelectorProps) => {
  return (
    <div className={cn("overflow-hidden relative", className)}>
      <div className="flex w-full h-[40px] bg-white overflow-auto hide-scrollbar gap-2">
        {subLabels.map((subLabel) => {
          const isSelectedLabel = selectedSubLabel.id === subLabel.id;

          return (
            <div key={subLabel.id} className="h-full">
              <div
                className={cn(
                  "flex items-center hover:cursor-pointer justify-center md:text-sm lg:text-sm xl:text-base w-auto rounded-[6px] h-full whitespace-nowrap",
                  isSelectedLabel ? "text-white bg-primary" : "text-gray bg-white",
                )}
                onClick={() => onSubLabelSelect(subLabel)}
              >
                <p className="text-center font-medium text-sm px-4">
                  {subLabel.label.split("\n").flatMap((line) => (
                    <span key={line}>
                      {line}
                      <wbr />
                    </span>
                  ))}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
